export const iconFontAwesomeDesignCubes = (
	<i className="fa-solid fa-cubes"></i>
);
